import { FC, useEffect } from "react";
import { ENTITY_ID_KEY } from "@jugl-web/utils/storage";
import { useNavigation } from "@web-src/modules/navigation/hooks/useNavigation";
import { useNavigateToRoleBasedInitialPage } from "@web-src/features/app/hooks/useNavigateToRoleBasedInitialPage";
import Loader from "@web-src/components/Loader";
import { useEntitiesListProvider } from "@web-src/features/entities/providers/EntitiesListProvider/useEntitiesListProvider";
import { useLocalStorage } from "@jugl-web/utils/hooks/useStorage";
import { useParams } from "react-router-dom";
import { getLoginFlow } from "@jugl-web/utils/hooks/useLoginFlow";

export const NavigateToDefaultEntity: FC = () => {
  const { navigateToPage } = useNavigation();
  const {
    entitiesState: { entities: list, isFetching: isEntitiesFetching },
    entityInvitesState: { entityInvites, isFetching: isEntityInvitesFetching },
  } = useEntitiesListProvider();
  const navigateToRoleBasedInitialPage = useNavigateToRoleBasedInitialPage();

  const [defaultEntityId] = useLocalStorage(ENTITY_ID_KEY, "");
  const { targetEntityId: paramsEntityId } = useParams<{
    targetEntityId: string;
  }>();
  const selectedEntity = paramsEntityId
    ? list?.find((entity) => entity.id === paramsEntityId)
    : list?.find((entity) => entity.id === defaultEntityId) || list?.[0];

  useEffect(() => {
    if (!isEntitiesFetching && !isEntityInvitesFetching) {
      if (selectedEntity) {
        navigateToRoleBasedInitialPage(selectedEntity);
      } else if (getLoginFlow() === "cx") {
        navigateToPage("cxOnboarding");
      } else if (entityInvites && entityInvites.length === 0) {
        navigateToPage("authSignUpPurpose");
      } else {
        navigateToPage("authInvitations");
      }
    }
  }, [
    isEntitiesFetching,
    isEntityInvitesFetching,
    selectedEntity,
    entityInvites,
    navigateToRoleBasedInitialPage,
    navigateToPage,
  ]);

  return <Loader className="h-screen w-screen" />;
};
